import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { englishFontFallbackMap, arabicFontFallbackMap } from 'src/screens/WhiteLabels/Templates/shared/fonts';
// material ui
import { ThemeProvider, StyledEngineProvider, createTheme, adaptV4Theme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import {Dialog,DialogActions,DialogContent,DialogTitle} from "@mui/material";
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
// components
import '../../assets/stylesheet/addcompany.css';

const TitleTheme = createTheme(adaptV4Theme({
    typography: {
      body1: {
          fontFamily:'inherit !important'
      },
      h6:{
        color:'#0F467A',
        fontFamily:'inherit',
        lineHeight:3.6,
        textAlign:'center',
        fontWeight:'bold',
      }
    },
}))

const styles = theme => ({
    startBtn:{
        width:'64px',
        height:'40px',
        backgroundColor:'#0F467A',
        border:'1px solid #707070',
        fontWeight:'bold',
        borderRadius:'5px',
        textAlign:'center',
        color:'#fff',
        textTransform:'capitalize',
        fontSize:'13px',
        lineHeight:3,
        cursor:'pointer',
    },

    label:{
        color:'#0F467A',
        fontSize:'16px',
        alignSelf:'flex-start',
        [theme.breakpoints.between('xs','md')]:{
            fontSize:'11px'
        }
    },

    backdrop: {
        zIndex: 111125,
        color: '#fff',
    },

    descInput:{
        border:'1px solid #E9E9E9',
        alignSelf:'center',
        justifyContent: 'start',
        outline: 'none',
        border: 'none',
        backgroundColor: '#F4F6F8',
        fontFamily: 'inherit',
        width: 'calc(100% - 20px)',
        margin: '10px 0px',
        padding: '10px',
        fontSize: '14px',
        borderRadius: '8px',
        resize: 'none',
        whiteSpace: 'pre-line',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
    },

    actionRoot:{
        padding:'8px 24px',
    },

    title:{
        [theme.breakpoints.between('xs','md')]:{
            padding:'0px 24px'
        }
    },

    dialogRoot:{
        zIndex:'11111111 !important'
    }
})

class EmailPhoneDialog extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleClose = () => {
        this.props.onClose();
    }

    inputHandle = e => {
        this._isMounted = true;
        if(this._isMounted) this.props.onChange(e.target.name,e.target.value)
    }
    
    render() {
        let { classes,t, i18n, email, mobileNumber, countryCode, phoneonChange, countryonChange, submitHandle, dispatch,tReady, companyFonts, ...other } = this.props;
        const isRTL = i18n.translator.language;
        const ar = "'Cairo', sans-serif";
        const en = "'Poppins', sans-serif";
        const englishFont = englishFontFallbackMap[companyFonts?.englishFont] || "'Poppins', serif";
        const arabicFont = arabicFontFallbackMap[companyFonts?.arabicFont] || '"Cairo", sans-serif';
        const fontFamily = isRTL === 'ar' ? arabicFont : englishFont;
    return (
        (<React.Fragment>
            <Dialog
                {...other}
                disableEscapeKeyDown
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                dir={isRTL === 'ar' ? 'rtl' : 'ltr'}
                style={{fontFamily}}
                fullWidth={true}
                classes={{root:classes.dialogRoot}}
                maxWidth='sm'>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={TitleTheme}>
                            <DialogTitle id="alert-dialog-title" classes={{root:classes.title}} style={{fontFamily}}>{t('booking.login_section.loginTitle')}</DialogTitle>
                    </ThemeProvider>
                </StyledEngineProvider>
                <DialogContent style={{display:'flex',flexDirection:'column'}}>
                    <div className='activityTimePicker'>
                        <span className={classes.label} style={{fontFamily,textTransform:'capitalize',fontWeight:'bold'}}>{t('profile-comp.email')}</span>
                        <input type="email" value={email} placeholder={t('profile-comp.email')} name="email" onChange={this.inputHandle} className={classes.descInput} />

                        <span className={classes.label} style={{fontFamily,textTransform:'capitalize',fontWeight:'bold'}}>{t('comp-comp.con-dialog.ph')}</span>
                        <PhoneInput
                            placeholder={t('comp-comp.con-dialog.ph')}
                            defaultCountry={countryCode}
                            value={mobileNumber}
                            style={{fontFamily}}
                            onChange={phoneonChange}
                            onCountryChange={countryonChange}
                            error={mobileNumber ? (isValidPhoneNumber(mobileNumber) ? undefined : t('booking.login_section.invalidNum')) : t('booking.login_section.phoneReq')}
                        />
                    </div>
                </DialogContent>
                <DialogActions classes={{root:classes.actionRoot}}>
                    <div className={classes.startBtn} style={{fontFamily}} onClick={submitHandle}>
                        {t('comp-comp.save')}
                    </div>
                </DialogActions>
            </Dialog>
        </React.Fragment>)
    );
    }
}


const mapStateToProps = state => {
    return {
        companyFonts: state.cpFonts,
    }
};

export default connect(mapStateToProps, null)(withStyles(styles)(withTranslation('common')(EmailPhoneDialog)));